module.exports = __webpack_public_path__ + "img/3diamond-04.a49a4192.svg";